export function searchBarClickListener() {
    document.getElementById("search-bar-focus").addEventListener("click", () => {
        document.getElementById("search-box").focus({preventScroll:true});
        const vari = document.getElementById("search-box");
        console.log(vari);
      });
}
